import { AppManifest } from './AppManifest';

export enum PageType {
  Home = 'Home',
  GetToKnow = 'GetToKnow',
  RestrictedItems = 'RestrictedItems',
  AccreditedPOSProviders = 'AccreditedPOSProviders',
  WhatIsProductLevelBlocking = 'WhatIsProductLevelBlocking',
  GoingLiveWithProductLevelBlocking = 'GoingLiveWithProductLevelBlocking',
  YourBusiness = 'YourBusiness',
  Definitions = 'Definitions',
  Eligibility = 'Eligibility',
  FrequentlyAskedQuestions = 'FrequentlyAskedQuestions',
  ContactUs = 'ContactUs',
  SignUpForProductLevelBlocking = 'SignUpForProductLevelBlocking',
  MerchantParticipationAgreement = 'MerchantParticipationAgreement'
}

interface Page {
  title: string,
  description: string,
  url: string
}

export const Pages: Record<PageType, Page> = {
  [PageType.Home] : { 
    title: `${AppManifest.EnvironmentMoniker}PLB Merchant Portal - Home`,
    description: 'Merchants can learn about and sign-up to Product Level Blocking (PLB), SmartCards and enhanced Income Management.',
    url: ''
  },
  [PageType.GetToKnow] : { 
    title: `${AppManifest.EnvironmentMoniker}Get to know the SmartCard`,
    description: 'Learn about the SmartCard.',
    url: 'get-to-know-the-SmartCard'
  },
  [PageType.RestrictedItems] : { 
    title: `${AppManifest.EnvironmentMoniker}Restricted items`,
    description: 'Learn which items cannot be purchased using the SmartCard.',
    url: 'restricted-items'
  },
  [PageType.AccreditedPOSProviders] : { 
    title: `${AppManifest.EnvironmentMoniker}Accredited POS Providers`,
    description: 'A list of PLB-accredited POS providers.',
    url: 'accredited-pos-providers'
  },
  [PageType.WhatIsProductLevelBlocking] : { 
    title: `${AppManifest.EnvironmentMoniker}What is Product Level Blocking`,
    description: 'What is Product Level Blocking.',
    url: 'what-is-product-level-blocking'
  },
  [PageType.GoingLiveWithProductLevelBlocking] : { 
    title: `${AppManifest.EnvironmentMoniker}Going live with Product Level Blocking`,
    description: 'The process of a business going live with Product Level Blocking.',
    url: 'going-live-with-plb'
  },
  [PageType.YourBusiness] : { 
    title: `${AppManifest.EnvironmentMoniker}Your business and the SmartCard`,
    description: 'Learn if your business can accept the SmartCard.',
    url: 'your-business-and-the-SmartCard'
  },
  [PageType.Definitions] : { 
    title: `${AppManifest.EnvironmentMoniker}PLB glossary`,
    description: 'A list of common terms and explanations used by PLB.',
    url: 'plb-glossary'
  },
  [PageType.Eligibility] : { 
    title: `${AppManifest.EnvironmentMoniker}Elibility`,
    description: 'Check if your business is eligible for Product Level Blocking.',
    url: 'eligibility'
  },
  [PageType.FrequentlyAskedQuestions] : { 
    title: `${AppManifest.EnvironmentMoniker}Frequently Asked Questions`,
    description: 'A list of frequently asked questions (FAQ) and answers for Product Level Blocking.',
    url: 'frequently-asked-questions'
  },
  [PageType.ContactUs] : { 
    title: `${AppManifest.EnvironmentMoniker}Contact Us`,
    description: 'Contact details for Product Level Blocking. Send a message to Product Level Blocking.',
    url: 'contact-us'
  },
  [PageType.SignUpForProductLevelBlocking] : { 
    title: `${AppManifest.EnvironmentMoniker}Sign up for Product Level Blocking`,
    description: 'Sign up for Product Level Blocking by filling in a Merchant Participation Agreement (MPA).',
    url: 'merchant-participation-agreement'
  },
  [PageType.MerchantParticipationAgreement] : { 
    title: `${AppManifest.EnvironmentMoniker}Merchant Participation Agreement`,
    description: 'Submit a merchant participation agreement (MPA) to implement Product Level Blocking for your business.',
    url: 'merchant-participation-agreement'
  },
};